import type { Editor, NodeEntry } from 'slate';
import { Transforms } from 'slate';

import { mergeWithDefaults } from '../../../util';
import type { FootersElement } from '../../internal';
import { createDefaultFooters } from '../../internal';

export function normalizeFootersPart(
  editor: Editor,
  footersPartEntry: NodeEntry<FootersElement>
): void {
  const [, footersPartPath] = footersPartEntry;
  if (footersPartPath.length > 1) {
    Transforms.moveNodes(editor, { at: footersPartPath, to: [editor.children.length] });
    return;
  }

  validateFootersPartProps(editor, footersPartEntry);
}

function validateFootersPartProps(
  editor: Editor,
  footersPartEntry: NodeEntry<FootersElement>
): void {
  const [footersPart, footersPartPath] = footersPartEntry;
  const { children: footersPartChildren, ...footersPartProps } = footersPart;
  const { children: defaultFootersPartChildren, ...defaultFootersPartProps } =
    createDefaultFooters();
  const missingKeys = Object.keys(defaultFootersPartProps).some(propKey => {
    const hasKey = propKey in footersPart;
    return !hasKey;
  });
  const newProps: Omit<FootersElement, 'children'> = mergeWithDefaults(
    footersPartProps,
    defaultFootersPartProps
  );
  if (!missingKeys) return;

  Transforms.setNodes(editor, newProps, { at: footersPartPath });
}
